import type {
  ConvertibleUnit,
  FormatOptions,
  Unit,
} from '@dynatrace-sdk/units';

import type { ChartUnit } from '../../../types/chart-unit.js';
import type { Formatter } from '../../../types/formatter.js';
import {
  formatValue,
  tickValueFormatter,
} from '../../../utils/format-value.js';
import { getFormatter } from '../../../utils/get-formatter.js';

interface GetFormattedContextValuesProps {
  unit: ChartUnit;
  formatter?: Formatter | FormatOptions<Unit, ConvertibleUnit>;
  domainValues: { min: number; max: number };
}

interface FormattedContextValues {
  formattedContextMaxValue: string;
  formattedContextMinValue: string;
}

export function getFormattedContextValues({
  unit,
  formatter,
  domainValues,
}: GetFormattedContextValuesProps): FormattedContextValues {
  const resolvedFormatter = getFormatter(formatter);
  const contextFormatter = resolvedFormatter ?? formatValue;
  const wrappedFormatter = tickValueFormatter(
    (value: number) => contextFormatter(value, unit),
    unit,
  );

  return {
    formattedContextMaxValue: wrappedFormatter(domainValues.max),
    formattedContextMinValue: wrappedFormatter(domainValues.min),
  };
}
